const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Zoom settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('zoomSettings', ['Application', 'CompanyIntegrations', 'ZoomIntegrate', function (Application, CompanyIntegrations, ZoomIntegrate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
    },
    template: require('../../templates/directives/zoom-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.zoomLink = Application.zoomLink;
      self.allowAI = Application.features.flags().enable_generative_ai;
      const domain = Application.companyDomain === 'staging.continu.co' ? 'learn2.continu.co' : Application.companyDomain;

      self.checkParams = function() {
        var params = Application.navigation.getUrlParameters();
        if (params.zoomcode) {
          ZoomIntegrate.create({}, {
            code: params.zoomcode,
            redirect_uri: `https://${domain}/zoom`
          }, function(data) {
            self.hasZoom = true;
            Application.messaging.addMessage({type: 'success', duration: 3, text: 'Zoom integration successful!'});
            Application.navigation.goTo('/overview/settings/integrations', {});
          }, function(err) {
            console.log('error in making slack integration: ', err);
            Application.navigation.goTo('/overview/settings/integrations', {});
          });
        }

      };
      
      self.initialize = function () {

        CompanyIntegrations.status({}, function (data) {
          self.companyIntegration = data || {};
          self.hasZoom = data.zoom || false;
          self.needsUpdate = data.zoomNeedsAIUpdate || false;

          self.checkParams();
        }, function (error) {
          console.log('Error occured getting company integration ', error);
        });

      };
      self.initialize();
    }],
    controllerAs: 'zoom'
  };
}]);
